import { createTheme } from "@mui/material/styles";
import { COMMON_COLORS, LIGHT_COLORS } from "./colors";

const lightTheme = createTheme({
    palette: {
        action: {
            hover: "rgba(0, 0, 0, 0.06)",
            selected: "rgba(0, 0, 0, 0.12)",
            focus: "rgba(0, 0, 0, 0.14)",
            disabled: "rgba(0, 0, 0, 0.26)",
            disabledBackground: "rgba(0, 0, 0, 0.14)"
        },
        primary: {
            main: COMMON_COLORS.primary
        },
        secondary: {
            main: COMMON_COLORS.secondary
        },
        background: {
            default: LIGHT_COLORS.backgroundDefault,
            paper: LIGHT_COLORS.backgroundPaper
        },
        text: {
            primary: LIGHT_COLORS.textPrimary,
            secondary: LIGHT_COLORS.textSecondary
        },
        chatEmptyStateTitle: LIGHT_COLORS.chatEmptyStateTitle,
        errorArrow: COMMON_COLORS.errorArrow,
        userMessageBG: LIGHT_COLORS.userMessageBG,
        white: COMMON_COLORS.white,
        black: COMMON_COLORS.black,
        containerBG: LIGHT_COLORS.containerBG,
        exampleContainer: LIGHT_COLORS.exampleContainer,

        pieChartFaded: LIGHT_COLORS.pieChartFaded,
        kpiCardTitle: LIGHT_COLORS.kpiCardTitle,
        kpiCardValue: LIGHT_COLORS.kpiCardValue,

        successColor: COMMON_COLORS.successColor,
        errorColor: COMMON_COLORS.errorColor,
        allLogColor: COMMON_COLORS.allLogColor,
        normalLogColor: COMMON_COLORS.normalLogColor,
        systemError: COMMON_COLORS.systemError,
        filteredChat: COMMON_COLORS.filteredChat,

        dateTime: LIGHT_COLORS.dateTime,
        chatHistoryUserMessageBubble: LIGHT_COLORS.chatHistoryUserMessageBubble,
        chatHistoryAiMessageBubble: LIGHT_COLORS.chatHistoryAiMessageBubble,
        citationsLabel: LIGHT_COLORS.citationsLabel,

        feedbackCardBG: LIGHT_COLORS.feedbackCardBG,
        feedbackCardHoverBG: LIGHT_COLORS.feedbackCardHoverBG,

        red: COMMON_COLORS.lightRed,

        gridRowHover: LIGHT_COLORS.gridRowHover,
        gridRowSelected: LIGHT_COLORS.gridRowSelected,
        fileGridHeaderBG: LIGHT_COLORS.fileGridHeaderBG,
        fileGridHeaderBorder: LIGHT_COLORS.fileGridHeaderBorder,
        fileGridBackground: LIGHT_COLORS.fileGridBackground,
        fileRowBackground: LIGHT_COLORS.fileRowBackground,

        alexxisTextGradientAccent: COMMON_COLORS.alexxisTextGradientAccent,
        loadingDotInitial: LIGHT_COLORS.loadingDotInitial,
        loadingDotMiddle: LIGHT_COLORS.loadingDotMiddle,
        loadingDotFinal: LIGHT_COLORS.loadingDotFinal,

        citationBackground: LIGHT_COLORS.citationBackground,
        citationBackgroundHover: LIGHT_COLORS.citationBackgroundHover,

        actionButtonBackground: LIGHT_COLORS.actionButtonBackground,
        actionButtonBackgroundHover: LIGHT_COLORS.actionButtonBackgroundHover,

        shortCutKeyBackground: LIGHT_COLORS.shortCutKeyBackground,
        scrollbarThumb: LIGHT_COLORS.scrollbarThumb,
        scrollbarTrack: LIGHT_COLORS.scrollbarTrack,

        drawerMenuBackground: LIGHT_COLORS.drawerMenuBackground,
        cardBackground: LIGHT_COLORS.cardBackground,
        datagridOverlayBackground: LIGHT_COLORS.datagridOverlayBackground,
        primaryButtonIcon: LIGHT_COLORS.primaryButtonIcon,
        primaryIcon: LIGHT_COLORS.primaryIcon,
        secondaryIcon: LIGHT_COLORS.secondaryIcon,

        borderColor: LIGHT_COLORS.borderColor,
        borderColorHover: LIGHT_COLORS.borderColorHover,

        disclaimerText: LIGHT_COLORS.disclaimerText,

        animatedTabBackground: LIGHT_COLORS.animatedTabBackground,
        animatedTabActiveBackground: LIGHT_COLORS.animatedTabActiveBackground,
        animatedTabText: LIGHT_COLORS.animatedTabText,
        animatedTabActiveText: LIGHT_COLORS.animatedTabActiveText,
        animatedTabHoverBackground: LIGHT_COLORS.animatedTabHoverBackground,
        animatedTabHoverText: LIGHT_COLORS.animatedTabHoverText,

        //File colors
        word: COMMON_COLORS.word,
        excel: COMMON_COLORS.excel,
        powerpoint: COMMON_COLORS.powerpoint,
        pdf: COMMON_COLORS.pdf,
        txt: COMMON_COLORS.txt,
        html: COMMON_COLORS.html,
        css: COMMON_COLORS.css,
        js: COMMON_COLORS.js,
        json: COMMON_COLORS.json,
        image: COMMON_COLORS.image,
        audio: COMMON_COLORS.audio,
        video: COMMON_COLORS.video,
        defaultFile: COMMON_COLORS.defaultFile,
        folder: COMMON_COLORS.folder,

        dropzoneBackground: LIGHT_COLORS.dropzoneBackground,
        dropzoneBorder: LIGHT_COLORS.dropzoneBorder,
        dropzoneBorderPulse: LIGHT_COLORS.dropzoneBorderPulse
    },
    typography: {
        fontFamily: '"TT Norms", sans-serif',
        fontSize: 16,
        h1: { fontSize: "3.5rem" },
        h2: { fontSize: "1.5rem" },
        h3: { fontSize: "1.25rem" }
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: "white",
                    "&:hover": {
                        color: "#28D7CA"
                    }
                }
            }
        },

        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#000",
                    borderRadius: "8px",
                    padding: "8px"
                },
                arrow: {
                    color: "#000"
                }
            }
        }
    }
});
export default lightTheme;
